import React, { useState } from "react";
import "../../../stylesheet/prescription.css";
import "../../../stylesheet/forms.css";
import Topnav from "../../others/Topnav";
import { BsCheck } from "react-icons/bs";
import ContextApi from "../../../context/ContextApi";
import ProductShelf from "../../inventory/ProductShelf";
import BillingDetails from "../../billings/BillingDetails";
import BillingSummary from '../BillingSummary';

const InventoryInvoice = () => {
  const [step, setStep] = useState(1);
  const [product, setProducts] = useState(null)
  const [details, setDetails] = useState(null)

  const handleContinue = () => {
    setStep((prevStep) => prevStep + 1);
  };
  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
      invoiceType: 'inventory'
    }));
  };

  const [formData, setFormData] = useState(null);

  const handleBack = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleSubmit = () => {
    handleContinue();
  };

  return (
    <div className="new">
      <Topnav />
      <ContextApi.Provider
        value={{
          product, setProducts,
          details, setDetails,
          formData, setFormData
        }}>
        <div className="form-container">
          <div className="progress-indicators place-self-center">
            <div className={`progress-step ${step >= 1 ? "active" : ""}`}>
              <div className={`progress-indicator`}>
                <span>{step > 1 ? <BsCheck /> : 1}</span>
              </div>
              <p className="progress-label">
                Inventory
                <br />
                details
              </p>
            </div>
            <div className="progress-bar">
              <div
                className="progress-bar-inner"
                style={{ width: `${(step - 1) * 100}%` }}
              />
            </div>

            <div className={`progress-step ${step >= 2 ? "active" : ""}`}>
              <div className={`progress-indicator`}>
                <span>{step > 2 ? <BsCheck /> : 2}</span>
              </div>
              <p className="progress-label">
                Billing <br /> Details
              </p>
            </div>
            <div className="progress-bar">
              <div
                className="progress-bar-inner"
                style={{ width: `${(step - 2) * 100}%` }}
              />
            </div>

            <div className={`progress-step ${step >= 3 ? "active" : ""}`}>
              <div className={`progress-indicator`}>
                <span> {step > 3 ? <BsCheck /> : 3}</span>
              </div>
              <p className="progress-label">
                Summary
              </p>
            </div>

          </div>
          <div className="w-full flex justify-center">
            {step === 1 && <ProductShelf onContinue={handleContinue} />} 
            {step === 2 && (
              <BillingDetails
                className="form-content"
                updateFormData={updateFormData}
                onContinue={handleContinue}
                goBack={handleBack}
              />
            )}
            {step === 3 && (
              <section className="form-content w-80">
                <BillingSummary
                  data={formData}
                  goBack={handleBack}
                />
              </section>
            )}
          </div>

        </div>
      </ContextApi.Provider>

    </div>
  );
};

export default InventoryInvoice;
